import React from 'react';
import { Check } from 'lucide-react';
import { GlowButton } from './ui/GlowButton';
import { AnalyticsDashboard } from './AnalyticsDashboard';
interface HeroSectionProps {
  onCtaClick?: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="relative min-h-0 lg:min-h-[85vh] flex items-center px-4 md:px-8 py-10 md:py-16 overflow-hidden" data-id="element-97">
      {/* Background Orbs */}
      <div className="absolute top-0 right-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-blue-600/10 rounded-full blur-[80px] md:blur-[120px] translate-x-1/3 -translate-y-1/4 animate-float pointer-events-none" data-id="element-98" />
      <div className="absolute bottom-0 left-0 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-purple-600/10 rounded-full blur-[80px] md:blur-[120px] -translate-x-1/3 translate-y-1/4 animate-float-delayed pointer-events-none" data-id="element-99" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10" data-id="element-100">
        {/* LEFT COLUMN: Copy Stack */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-101">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-6 animate-fade-in-up" data-id="element-102">
            <span className="relative flex h-2 w-2" data-id="element-103">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-104"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-105"></span>
            </span>
            <span className="label-caps text-[10px] sm:text-[11px] text-gray-400" data-id="element-106">
              Faceless YouTube System
            </span>
          </div>

          {/* Headline */}
          <h1 className="animate-fade-in-up delay-100 mb-4" data-id="element-107">
            <span className="text-white block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black tracking-[-0.03em] leading-[1.08]" data-id="element-108">
              Build a Profitable
            </span>
            <span className="text-gradient block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black tracking-[-0.03em] leading-[1.08] mt-0.5" data-id="element-109">
              Faceless YouTube Channel
            </span>
            <span className="block text-sm sm:text-base md:text-lg lg:text-xl font-medium text-gray-500 mt-3 tracking-[-0.01em] leading-snug" data-id="element-110">
              Even if you're starting from zero
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xs sm:text-sm md:text-[15px] text-gray-400 max-w-md mb-6 animate-fade-in-up delay-200 leading-[1.7] tracking-[0.01em]" data-id="element-111">
            Get a done-for-you channel designed to grow, monetize, and earn. No
            face, no filming, no guesswork.
          </p>

          {/* Benefit Bullets */}
          <div className="flex flex-col gap-2.5 mb-7 animate-fade-in-up delay-300 w-full" data-id="element-112">
            {['Data-backed niche & channel strategy', 'Done-for-you content production', 'Built for fast monetization & scale'].map((item, i) => <div key={i} className="flex items-center gap-2.5 text-xs sm:text-sm font-medium text-gray-300 justify-center lg:justify-start" data-id="element-113">
                <div className="bg-green-500/20 p-0.5 rounded-full flex-shrink-0" data-id="element-114">
                  <Check className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-green-500" data-id="element-115" />
                </div>
                <span data-id="element-116">{item}</span>
              </div>)}
          </div>

          {/* CTA Area */}
          <div className="flex flex-col items-center lg:items-start gap-2.5 animate-fade-in-up delay-300 w-full sm:w-auto" data-id="element-117">
            <GlowButton className="w-full sm:w-auto" onClick={onCtaClick} data-id="element-118">
              Start My Faceless Channel
            </GlowButton>
            <p className="label-caps text-[9px] sm:text-[10px] text-gray-500 tracking-[0.12em]" data-id="element-119">
              Limited spots. We onboard a small group each month.
            </p>
          </div>
        </div>

        {/* RIGHT COLUMN: Visual Authority */}
        <div className="relative w-full flex justify-center lg:justify-end animate-fade-in-up delay-200 mt-4 lg:mt-0" data-id="element-120">
          <AnalyticsDashboard data-id="element-121" />
        </div>
      </div>
    </section>;
}